<template>
    <img class="logo" alt="Sckan NLI logo" src="./assets/sckan-nli-beta-logo.svg">
    <OrcidWidget :clientId="clientID" env="production" redirectUri="https://fdi-nlp.ucsd.edu/callback" />
</template>
<script>
import OrcidWidget from './components/OrcidWidget.vue';
export default {
    props: ["error"],
    name: 'LoginView',
    data() {
        return {
            clientID: process.env.VUE_APP_CLIENT_ID,
        }
    },
    components: {
        OrcidWidget
    },


}
</script>
<style>
.logo {
    width: auto;
    height: 200px;
}
</style>
